import CommonAnalytics from 'analytics';
import hubSpotPlugin from '@analytics/hubspot';
import fullStoryPlugin from '@analytics/fullstory';
import googleTagManager from '@analytics/google-tag-manager';
import googleAnalyticsPlugin from '@analytics/google-analytics';
import intercomPlugin from '@analytics/intercom';

const config = require("./config.json");
const intercomAppId = config.INTERCOM_APP_ID; // Add intercome app id for connectivity

const production = window.location.hostname === "app.flowtrace.io";
const localhost = window.location.hostname === "localhost";
const plugins = [];

// PROD
if(production)
  [
    fullStoryPlugin({ org: 'VR7V1' }),
    hubSpotPlugin({ portalId: '7761721' }),
    googleAnalyticsPlugin({ measurementIds: ['G-D6NGGJZBFP'] }),
    googleTagManager({ containerId: 'AW-625517572' }),
    intercomPlugin({ appId: intercomAppId }),
  ].forEach(plugin => plugins.push(plugin));
else if(localhost) // LOCAL / TEST
  {
    console.log("Analytics plugins are disabled in localhost environment");
  }
else // DEV etc.
  [
    intercomPlugin({ appId: intercomAppId }),
  ].forEach(plugin => plugins.push(plugin));

const commonAnalytics = CommonAnalytics({
  app: 'flowtrace',
  //debug: !production,
  plugins,
});

export default commonAnalytics;
